import { Component, OnInit } from '@angular/core';
import {ContentControllerService} from "../content-controller.service";

@Component({
  selector: 'app-equipment-gliders',
  templateUrl: './equipment-gliders.component.html',
})
export class EquipmentGlidersComponent implements OnInit {

  equipmentContent: any;
  glidersContent: any;
  gliderInfo: any[] = [];

  constructor(private contentControllerService: ContentControllerService) { }

  ngOnInit() {
    // this.contentControllerService.getPage('equipment').then(response =>{
    //       this.equipmentContent = response['items'][0];
    // });
    //
    // this.contentControllerService.getEquipment().then(response =>{
    //     this.glidersContent = response['items'];
    //
    //     for(let i=0; i<response['items'].length; i++){
    //         let id = this.glidersContent[i].id;
    //         this.contentControllerService.getGliders(id).then(response =>{
    //             this.gliderInfo.push(response);
    //         })
    //     }
    // });
  }
}
